import React from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';

export const MetaHelmet = ({ title, companyName }) => (
  <Helmet>
    <title>
      {' '}
      {title} | {companyName}{' '}
    </title>
  </Helmet>
);

MetaHelmet.propTypes = {
  title: PropTypes.string,
  companyName: PropTypes.string,
};
